<template>
  <div class="superset-container">
  <iframe :src="iframeSrc" style="width: 100%; height: 100vh; border: none;"></iframe>
  </div>
</template>

<script>
export default {
  name: "AdvancedDashboard",
  data() {
    return {
      supersetUrl: "https://superset.dev.talentfind.io"
    };
  },
  computed: {
    guestToken() {
      return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVzZXJuYW1lIjoiYWRtaW5Ab2hyYWdlbmN5LnN0YWdlIiwiZmlyc3RfbmFtZSI6IkFkbWluIiwibGFzdF9uYW1lIjoiT0hSIEFnZW5jeSBVc2VyIn0sInJlc291cmNlcyI6W3sidHlwZSI6ImRhc2hib2FyZCIsImlkIjoiOTAxNDc0OWYtMDBhMi00Zjc5LWIwYTEtNzFmMjU2MGZiZDlhIn1dLCJybHNfcnVsZXMiOltdLCJpYXQiOjE3NzUzMTc1MDAuNDk0MjA0LCJleHAiOjE3NzUzMTc4MDAuNDk0MjA0LCJhdWQiOiJodHRwczovL3N1cGVyc2V0LmRldi50YWxlbnRmaW5kLmlvIiwidHlwZSI6Imd1ZXN0In0.DZbJAb_qUKbnHOAo9sroYnNuFelALGOyW8Q6gymeQ4o"
    },
    iframeSrc() {
      return `${this.supersetUrl}/superset/dashboard/1/?standalone=3&show_filters=0&theme=light`
    }
  },

};
</script>

<style>
.superset-container {
  width: 100%;
  height: 100%;
}
</style>